$(document).ready(function(){
  var topval = $('#sidebar').offset().top;
	$(window).scroll(function () {  
   		var scrll = $(this).scrollTop();
  		if (scrll > topval) {
    		var ftr_hight =   $('#related_items').offset().top;
 	 		var footer_fixed_h =  $('#related_items').outerHeight();
 	 		var length_f =  ftr_hight-footer_fixed_h-70;
   			//console.log(scrll+'------bottom hight'+ftr_hight+'-- div height'+footer_fixed_h+'==='+length_f);
    
    	 	if(scrll<length_f){
  				//	console.log('fixed');
    		 	$('#sidebar').addClass('fixed').removeAttr('style');
 		 	}
  			else{
         		// console.log('absolute');
        		$('#sidebar').removeClass('fixed').css({
                    position: 'absolute',
                    top: (length_f-170) + 'px',
              		width: '565px'
                });
  			}
  		}
  		else{
            $('#sidebar').removeClass('fixed');
  		}
 
	});
});